import React, { useEffect } from 'react';
import { LiveModelPreviewTable } from './LiveModelPreviewTable';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import useStyles from './style';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router';
import routes from '../../components/Router/routes';
import Mixpanel from 'mixPanel';
import { useQuery } from '@tanstack/react-query';
import { getCompany } from './service';

const LiveModelPreview = () => {
  const styles = useStyles();
  const { companyId } = useParams<{ companyId: string }>();
  const { data: company, isLoading } = useQuery(
    ['company', companyId],
    () => getCompany(companyId),
    {
      enabled: !!companyId,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      refetchOnMount: false,
      refetchOnReconnect: false
    }
  );
  const history = useHistory();

  useEffect(() => {
    Mixpanel.track('marketplace:company_preview_page_view', { companyId });
    if (!companyId) {
      history.replace(routes.ERROR_404);
    }
  }, [companyId, history]);

  return (
    <Box className={styles.pageContainer}>
      {isLoading ? (
        <Box className={styles.progressWrapper}>
          <CircularProgress variant={'indeterminate'} />
        </Box>
      ) : (
        <>
          {!!company?.name && !!company?.ticker && (
            <Typography variant={'h5'}>
              {company.name} ({company.ticker})
            </Typography>
          )}
          <LiveModelPreviewTable companyId={companyId} />
        </>
      )}
    </Box>
  );
};

export default LiveModelPreview;
